export enum START_PAGE {
  SAMPLE = 'sample',
  TEMPLATE = 'template',
  PRICE_LIST = 'prices',
  ORDERS = 'orders',
  UPLOAD = 'upload',
  CONFIGURATION = 'configuration',
  LOGISTICS = 'logistics',
  BILLS = 'bills',
  SAMPLE_STORAGE = 'sampleStorage',
  HOME = 'home',
}
